import React, { useState } from 'react';
import { Popup, Button, RadioGroup } from 'devextreme-react';
export const DialogWithOptions = ({ closeDialog, priorityEntities,handleChangeDimensionButtonClick,selectionPriority,setSelectionPriority,formFields,setformFields }) => {
    const changeSelectionPriority = (e) => {
        setSelectionPriority(e.value);  
        setformFields(prevFields => ({
            ...prevFields,
            UpdateDimensionOptions: e.value,
        }));
    };
    const handleButtonClick = () => {
        handleChangeDimensionButtonClick(selectionPriority);   
    };
    return (
        <Popup
            visible={true}  
            onHiding={closeDialog}
            title="Confirm"
            showCloseButton={true}
            width={600}
            height={450}
        >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                    Area and Volume have been changed. Do you wish to modify capacity values?
                </div>
                <RadioGroup
                    items={priorityEntities}  
                    value={selectionPriority}   
                    onValueChanged={changeSelectionPriority}   
                    layout="vertical" 
                    displayExpr="text"  
                    valueExpr="id"   
                />
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                    <Button
                        text="OK"
                        onClick={handleButtonClick}
                        style={{ marginRight: '10px' }}  
                    />
                    <Button
                        text="Cancel"
                        onClick={closeDialog}
                    />
                </div>
            </div>
        </Popup>
    );
};
